var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoNotDisturbOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "not",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 20,
    height: 20,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2125",
    "data-name": "Groupe 2125",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2124",
    "data-name": "Groupe 2124",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_779",
    "data-name": "Trac\\xE9 779",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,18a8,8,0,0,1-8-8A7.9,7.9,0,0,1,3.69,5.1L14.9,16.31A7.9,7.9,0,0,1,10,18m6.31-3.1L5.1,3.69A7.9,7.9,0,0,1,10,2a8,8,0,0,1,8,8,7.9,7.9,0,0,1-1.69,4.9",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoNotDisturbOutlined);
export default __webpack_public_path__ + "static/media/DoNotDisturbOutlined.8f6906018d7f1d6dae9a39c13b6d1be0.svg";
export { ForwardRef as ReactComponent };